















import { Component, Prop, Vue } from "vue-property-decorator";
import CzCard from "../cz/CzCard.vue";
import CzChip from "../cz/CzChip.vue";
import CzTitle from "../cz/CzTitle.vue";
import CzCover from "../cz/CzCover.vue";
import CzIcon from "../cz/CzIcon.vue";

@Component({ components: { CzCard, CzChip, CzTitle, CzCover, CzIcon } })
export default class ProgramPill extends Vue {
  @Prop({ type: String, required: true }) to!: string;
  @Prop({ type: String, default: "" }) tag!: string;
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) description!: string;
  @Prop({ type: String, default: "" }) goLabel!: string;
  @Prop({ type: Boolean, default: false }) muted!: boolean;
}
